import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import { useEffect } from "react";
import { fetchMezzi } from "../../../features/Mezzi/mezziThunk";
import { selectMezzi,selectError, selectIsLoading } from "../../../features/Mezzi/mezziSlice";
import { CircularProgress, Box } from "@mui/material";
import { fetchCompanies } from "../../../features/company/companyThunk";

const SubMezzi = () => {
    const columns = [
        { field: "name", headerName: "Nome del mezzo", width: 650 },
        { field: "tipo_mezzo", headerName: "Tipologia mezzo", width: 165 },
        { field: "targa", headerName: "Targa", width: 120 },
        // { field: "stato", headerName: "Stato Documenti", width: 165 },
        { field: "anno_acquisto", headerName: "Anno di acquisto", width: 177 },
        { field: "azioni", headerName: "Azioni", width: 60, sortable: false }
      ];
      const dispatch = useDispatch()
      const mezzi = useSelector(selectMezzi) || []
      const mezziLoading = useSelector(selectIsLoading)
      const mezziError = useSelector(selectError)

      const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  useEffect(() => {
      dispatch(fetchMezzi())
  },[dispatch, selectSelectedCompany])

  useEffect(() => {
    dispatch(fetchCompanies())
  },[])
      const mappedData = mezzi.map((item) => ({
        id: item?.id,
        name: item?.name,
        tipo_mezzo: item?.tipo_mezzo,
        targa: item?.targa,
        anno_acquisto: item?.anno_acquisto,
        volume: item?.volume,
        total_km: item?.total_km,
        status:item?.status
        // codEan: item.ean_code,
        // denominazione: item.denominazione?.toUpperCase(),
      }));

  return (
    <div className="pageTemplate">
      {mezziLoading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <Table
          data={mappedData?.length ? mappedData : []}
          columns={columns}
          navData={"structureMezzi"}
          deleteFunctions={"deleteMezziData"}
        />
      )}
    </div>
  );
};

export default SubMezzi;
